import {
  Sparkles, Radio, Flame, Gamepad2, Layers3, Wallet, Bot, Trophy, Store, HelpCircle,
} from "lucide-react";
/**
 * Tour steps — each step either highlights a target selector on the current page
 * or navigates to `route` first, then highlights. If no `selector`, the step
 * renders as a centered modal (welcome / finale).
 *
 * placement: "top" | "bottom" | "left" | "right" | "center" (auto = center if none)
 */
export const TOUR_STEPS = [
  {
    id: "welcome",
    title: "Welcome to GameEdge",
    body: "Let's take a 60-second tour of the tools you'll use every day. You can skip anytime and replay this from the user menu.",
    icon: Sparkles,
    placement: "center",
    cta: "Show me around",
  },
  {
    id: "kpis",
    route: "/dashboard",
    selector: '[data-testid="kpi-roi"]',
    title: "Your performance KPIs",
    body: "ROI, win rate, net profit, and current streak update in real time as your tracked bets settle. This is your P&L at a glance.",
    icon: Trophy,
    placement: "bottom",
  },
  {
    id: "top-edges",
    route: "/dashboard",
    selector: '[data-testid="view-all-games-link"]',
    title: "Today's top edges",
    body: "Ranked by expected value (EV) across moneyline, spread, and total markets — generated from our Monte Carlo simulations vs the live market.",
    icon: Flame,
    placement: "bottom",
  },
  {
    id: "scoreboard",
    route: "/scores",
    selector: '[data-testid="nav-scores"]',
    title: "Live Scoreboard",
    body: "See live, final, and scheduled games across every supported league. Finished games automatically settle your tracked bets.",
    icon: Radio,
    placement: "right",
  },
  {
    id: "daily-picks",
    route: "/daily-picks",
    selector: '[data-testid="nav-daily-picks"]',
    title: "Daily Picks",
    body: "Our model's highest-EV plays of the day, filtered to credible picks only. Tap Track to log one to your personal ledger.",
    icon: Flame,
    placement: "right",
  },
  {
    id: "live-odds",
    route: "/games",
    selector: '[data-testid="nav-games"]',
    title: "Live Odds",
    body: "Every upcoming game with moneyline, spread, and total odds. Tap a game to run a full Monte Carlo simulation.",
    icon: Gamepad2,
    placement: "right",
  },
  {
    id: "bookmakers",
    route: "/bookmakers",
    selector: '[data-testid="nav-bookmakers"]',
    title: "Line Shop",
    body: "Compare the same market across 9+ sportsbooks. Line shopping is the #1 predictor of long-term ROI.",
    icon: Store,
    placement: "right",
  },
  {
    id: "simulator",
    route: "/simulate",
    selector: '[data-testid="nav-simulate"]',
    title: "Monte Carlo Simulator",
    body: "Run 10,000 iterations on any matchup to see projected scores, win probabilities, and EV by market.",
    icon: Sparkles,
    placement: "right",
  },
  {
    id: "parlay",
    route: "/parlay",
    selector: '[data-testid="nav-parlay"]',
    title: "Parlay Builder",
    body: "Build multi-leg tickets with proper same-game correlation modeling — most books mis-price these. That's your edge.",
    icon: Layers3,
    placement: "right",
  },
  {
    id: "mybets",
    route: "/my-bets",
    selector: '[data-testid="auto-settle-bets-btn"]',
    title: "Auto-settle bets",
    body: "Track any bet, and we'll auto-mark it Won/Lost from real final scores. ROI compounds automatically.",
    icon: Wallet,
    placement: "bottom",
  },
  {
    id: "factors",
    route: "/factors",
    selector: '[data-testid="nav-factors"]',
    title: "Self-learning engine",
    body: "Our 14-factor model adjusts its weights after every settled outcome. The more bets clear, the sharper the predictions.",
    icon: Bot,
    placement: "right",
  },
  {
    id: "clv",
    route: "/clv",
    selector: '[data-testid="nav-clv"]',
    title: "CLV report",
    body: "Closing Line Value — the gold-standard skill signal. Consistently beating the close means you're sharper than the market.",
    icon: Trophy,
    placement: "right",
  },
  {
    id: "done",
    title: "You're all set",
    body: "You can replay this tour anytime from the user menu in the top-right. Happy hunting — may your CLV stay positive.",
    icon: HelpCircle,
    placement: "center",
    cta: "Start exploring",
  },
];

export const TOUR_SEEN_KEY = "gameedge.tour.v1.completed";
